angular
  .module("AccountingBoxApp")
  .controller("EditBankRuleCtrl", function(
    $scope,
    $state,
    $filter,
    $stateParams,
    BankRule,
    Account,
    VatCode,
    SubAccount
  ) {
    var vm = this;
    var bankRule;
    $scope.isNewBankRule = false;

    vm.save = function(bankRule) {
      $scope.submitted = true;
      var bA = new BankRule(bankRule);
      // if (bankRule.account) {
      //   bankRule.accountNumber = bankRule.account.accountNumber;
      // }
      // if (bankRule.subAccount) {
      //   bankRule.subAccountId = bankRule.subAccount.id;
      // }
      // if (bankRule.vatCode) {
      //   bankRule.vatCodeId = bankRule.vatCode.id;
      // }
      bA.$save().then(function() {
        $scope.$emit("bankRuleSaved", bankRule);
        $scope.$emit("closeBankRule", null);
      });
    };

    vm.addCondition = function() {
      vm.bankRule.conditions.push({});
    };

    vm.removeCondition = function(condition) {
      if (vm.bankRule.conditions.length < 2) {
        return;
      }
      vm.bankRule.conditions.splice(
        vm.bankRule.conditions.indexOf(condition),
        1
      );
    };

    $scope.$on("editBankRule", function(e) {
      bankRule = BankRule.get({
        id: $scope.bankRule.id
      });
      $scope.isNewBankRule = false;
      vm.bankRule = bankRule;
    });

    $scope.$on("newBankRule", function(e) {
      bankRule = new BankRule();
      $scope.isNewBankRule = true;
      bankRule.type = "";
      bankRule.conditionMatchingType = "ALL";
      bankRule.conditions = [
        { field: "description", operator: "CONTAINS", value: "" }
      ];
      vm.bankRule = bankRule;
    });

    vm.cancel = function() {
      $scope.$emit("closeBankRule", null);
    };

    vm.removeBankRuleConfirmation = function(bankRule) {
      $scope.$emit("removeBankRuleConfirmation", bankRule);
    };

    setTimeout(function() {
      vm.accounts = Account.findApplicable();
      vm.vatCodes = VatCode.find({
        filter: {
          where: {
            or: [{ sale: true }, { purchase: true }]
          }
        }
      });
      vm.refreshSubAccounts();
    }, 10);

    // Account.systemAccounts(function(result) {
    //   vm.systemAccounts = result.systemAccounts;
    // });

    vm.refreshSubAccounts = function() {
      SubAccount.find(function(subAccounts) {
        vm.subAccounts = subAccounts;
      });
    };
  });
